import {
  computed,
  toRefs,
} from 'vue';

import { useAuthStore } from '@/store/authStore';
import type { Role } from '@/store/authStore';

interface UserRoleReturnType {
  role: Role;
  isAgent: boolean;
  isRepres: boolean;
}

export const useUserRole = (): UserRoleReturnType => {
  const authStore = useAuthStore();
  const { role } = toRefs(authStore);

  if (!role.value) {
    throw new Error(`User role is not defined: ${ role.value } `);
  }

  const isAgent = computed(() => role.value === 'agent');
  const isRepres = computed(() => role.value === 'repres');

  return {
    role: role.value,
    isAgent: isAgent.value,
    isRepres: isRepres.value,
  };
};
